import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    familiares: [],
  },

  getters: {
    getFamiliares: (state) => state.familiares,
  },

  mutations: {
    SET_FAMILIARES(state, familiares) {
      state.familiares = familiares;
    },
  },

  actions: {
    async fetchFamiliares({ commit }, idPersonal) {
      await axios
        .get(`PoliciaCuadrantes/C3/personal/${idPersonal}/familiares`)
        .then((response) => {
          commit('SET_FAMILIARES', response.data.data);
        });
    },

    async saveFamiliares(_, familiares) {
      await axios
        .post(`PoliciaCuadrantes/C3/personal/${familiares.fk_idPersonal}/familiares`, familiares)
        .then(() => {});
    },

    async updateFamiliares(_, familiares) {
      await axios
        .put(`PoliciaCuadrantes/C3/personal/${familiares.fk_idPersonal}/familiares/${familiares.fk_idFamiliares}`, familiares);
    },
  },
};
